/** Maps activity log module keys to admin nav / section label keys. */
export const ACTIVITY_MODULE_LABEL_KEYS = {
  pages: 'admin.nav.pages',
  homepage: 'admin.nav.homepage',
  hero_slider: 'admin.nav.heroSlider',
  story_cards: 'admin.nav.storyCards',
  news: 'admin.nav.news',
  events: 'admin.nav.events',
  gallery: 'admin.nav.gallery',
  menus: 'admin.nav.menus',
  settings: 'admin.nav.settings',
  users: 'admin.nav.users',
  forms_applications: 'admin.forms.applications',
  forms_counseling: 'admin.forms.counseling',
  forms_contact: 'admin.forms.contact',
  recruitment_vacancies: 'admin.recruitment.vacancies',
  recruitment_applications: 'admin.recruitment.applications',
  recruitment_departments: 'admin.recruitment.departments',
  recruitment_statuses: 'admin.recruitment.statuses',
  recruitment_settings: 'admin.recruitment.settings',
}

export function activityModuleLabel(module, t) {
  if (!module) return '—'
  const key = ACTIVITY_MODULE_LABEL_KEYS[module]
  return key ? t(key) : module
}

const ACTION_LABEL_KEYS = {
  create: 'admin.activity.actions.create',
  update: 'admin.activity.actions.update',
  delete: 'admin.activity.actions.delete',
}

const ACTION_BADGE_CLASS = {
  create: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  update: 'bg-sky-50 text-sky-700 ring-1 ring-sky-200',
  delete: 'bg-red-50 text-red-700 ring-1 ring-red-200',
}

export function activityActionLabel(action, t) {
  if (!action) return '—'
  const key = ACTION_LABEL_KEYS[action]
  return key ? t(key) : action
}

export function activityActionBadgeClass(action) {
  return ACTION_BADGE_CLASS[action] || 'bg-background text-text/70 ring-1 ring-border'
}

export function activitySubjectLabel(log) {
  const label = log?.subject_label || log?.description
  return typeof label === 'string' && label.trim() ? label.trim() : null
}
